// Metered-overage constants for the Tour Dates Automation Package. Money is
// integer cents; see docs/specs/credits-pricing-approach.md.

import type { AutomationsBillingInterval } from "./automations-plans";

/** $15 per 10,000 credits, in cents: the overage rate and the plan's cost-plus rate. */
export const OVERAGE_CENTS_PER_10K_CREDITS = 1500;

export const OVERAGE_CAP_MIN_CENTS = 1000;
export const OVERAGE_CAP_MAX_CENTS = 500_000;
export const OVERAGE_CAP_DEFAULT_CENTS = 5000;

/** D35: annual plans carry no metered item until M24 attaches one. */
export const overageAvailable = (
  interval: AutomationsBillingInterval | null
): boolean => interval === "monthly";

/** Credits one text costs — in pricing, wallet debits and every copy string. */
export const CREDITS_PER_TEXT = 10;

/** Clamps a hand-typed overage-cap cents value to [MIN, MAX], falling back
 *  to the default for non-finite input. */
export function clampOverageCapCents(cents: number): number {
  if (!Number.isFinite(cents)) return OVERAGE_CAP_DEFAULT_CENTS;
  return Math.min(
    OVERAGE_CAP_MAX_CENTS,
    Math.max(OVERAGE_CAP_MIN_CENTS, Math.round(cents))
  );
}

/** A cap in integer cents from a raw metadata value; null when absent, blank, non-integer or out of range. */
export function parseOverageCapCents(raw: unknown): number | null {
  if (typeof raw !== "string" && typeof raw !== "number") return null;
  if (typeof raw === "string" && raw.trim() === "") return null;
  const cents = Number(raw);
  return Number.isInteger(cents) &&
    cents >= OVERAGE_CAP_MIN_CENTS &&
    cents <= OVERAGE_CAP_MAX_CENTS
    ? cents
    : null;
}
